export const Server = 'https://future.brandmarkt.ch/admin_backend/public'


// export const Server = 'http://localhost:8000'